// extracted by mini-css-extract-plugin
export var aiStarIcon = "_jj-2";
export var container = "_jj-4";
export var dismissButton = "_jj-3";
export var hasPaddingBottom = "_jj-6";
export var last = "_jj-e";
export var scrollbarThumb = "_jj-c";
export var scrollbarTrack = "_jj-b";
export var selected = "_jj-9";
export var spin = "_jj-1";
export var spinning = "_jj-0";
export var suggestionItem = "_jj-d";
export var suggestionsPanel = "_jj-5";
export var tonePill = "_jj-8";
export var tonesContainer = "_jj-7";
export var unselected = "_jj-a";